import React, { useEffect } from 'react';
import { CheckCircle, AlertCircle, Info, XCircle, X } from 'lucide-react';

const Toast = ({ message, type = 'info', duration = 3000, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const types = {
    success: {
      icon: CheckCircle,
      bgColor: 'bg-[#e8f7f3]',
      borderColor: 'border-green-500',
      textColor: 'text-[#03a685]',
      iconColor: 'text-green-500'
    },
    error: {
      icon: XCircle,
      bgColor: 'bg-red-50',
      borderColor: 'border-red-500',
      textColor: 'text-red-800',
      iconColor: 'text-red-500'
    },
    warning: {
      icon: AlertCircle,
      bgColor: 'bg-yellow-50',
      borderColor: 'border-yellow-500',
      textColor: 'text-yellow-800',
      iconColor: 'text-yellow-500'
    },
    info: {
      icon: Info,
      bgColor: 'bg-[#fff8fa]',
      borderColor: 'border-[#ff3f6c]',
      textColor: 'text-[#ff3f6c]',
      iconColor: 'text-[#ff3f6c]'
    }
  };

  const config = types[type] || types.info;
  const Icon = config.icon;

  return (
    <div className="fixed top-4 right-4 z-[9999] animate-slide-in-right">
      <div className={`${config.bgColor} ${config.borderColor} border-l-4 rounded-lg shadow-lg p-4 flex items-start gap-3 max-w-md`}>
        <Icon size={24} className={`${config.iconColor} flex-shrink-0 mt-0.5`} />
        <div className={`flex-1 ${config.textColor}`}>
          <p className="text-sm font-medium whitespace-pre-wrap">{message}</p>
        </div>
        <button
          onClick={onClose}
          className={`${config.iconColor} hover:opacity-70 transition-opacity flex-shrink-0`}
        >
          <X size={18} />
        </button>
      </div>
    </div>
  );
};

export default Toast;
